
import {differenceWith, isEmpty, isEqual, join, map} from 'lodash';

import {getClonedObject} from './common-util.js';
import {DateUtil} from './date-util.js';
import {AGGREGATION_DATES, DASHBOARD_SEARCH_CRITERIA_KEYS} from '../components/shared/charts-and-grids/charts-util.js';
import {OPERATOR_OPTIONS} from '../components/shared/search-criteria-modal/search-criteria-modal-util.js';
import {COMMA} from './constants.js';

/**
 * criteriaDetails -> OBJECT with below structure
 * criteriaName: {
 *      selectedValue: string
 * },
 * criteriaOperator: string (symbols),
 * criteriaValue: {
 *      selectedValues: array of string values
 * }
 *
 * whitelistedParameters: array of keys which will be part of the payload. If empty, then all keys passed will be
 * part of the payload
 */

export const requestBuilder = (criteriaDetails, whitelistedParameters) => {
    const areAllSelected = (selected, all) => selected.length === all.length;
    const isNotEqualOperator = (selectedCriteriaOperator) => selectedCriteriaOperator === OPERATOR_OPTIONS[1].value;
    const isWhitelistedParameter = selectedCriteriaName => whitelistedParameters.indexOf(selectedCriteriaName) > -1;
    const isCriteriaFareType = selectedCriteriaName => selectedCriteriaName === DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_FARE_TYPE;
    const requestData = {};

    if (criteriaDetails && !isEmpty(criteriaDetails)) {
        requestData.fromDate = `${DateUtil.formatDate(criteriaDetails[DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_AGGREGATION_DATE][AGGREGATION_DATES.AGGREGATION_FROM_DATE], DateUtil.DATE_FORMATS.YEAR_MONTH_DAY)}`;
        requestData.toDate = `${DateUtil.formatDate(criteriaDetails[DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_AGGREGATION_DATE][AGGREGATION_DATES.AGGREGATION_TO_DATE], DateUtil.DATE_FORMATS.YEAR_MONTH_DAY)}`;

        map(criteriaDetails.filterBy, eachCriteria => {
            const criteriaName = eachCriteria.criteriaName;
            const criteriaOperator = eachCriteria.criteriaOperator;
            const criteriaValue = eachCriteria.criteriaValue;

            if (!areAllSelected(criteriaValue.selectedValues, criteriaValue.allOptions) && isWhitelistedParameter(criteriaName.selectedValue)) {
                let selectedCriteriaValues = getClonedObject(criteriaValue.selectedValues);
                if (isNotEqualOperator(criteriaOperator)) {
                    selectedCriteriaValues = differenceWith(criteriaValue.allOptions, selectedCriteriaValues, isEqual);
                }
                if (isCriteriaFareType(criteriaName.selectedValue)) {
                    map(selectedCriteriaValues, eachSelectedCriteriaValue => {
                        if(eachSelectedCriteriaValue.value === 'OW') {
                            eachSelectedCriteriaValue.value = 1;
                        } else if(eachSelectedCriteriaValue.value === 'RT') {
                            eachSelectedCriteriaValue.value = 2;
                        } else if(eachSelectedCriteriaValue.value === 'OWNC') {
                            eachSelectedCriteriaValue.value = 3;
                        }
                    });
                    requestData[criteriaName.selectedValue] = join(map(selectedCriteriaValues, 'value'), COMMA);
                } else {
                    requestData[criteriaName.selectedValue] = join(map(selectedCriteriaValues, 'value'), COMMA);
                }
            }
        });
    }

    return isEmpty(requestData) ? null : requestData;
};
